import moment from 'moment'
import momentHijri from 'moment-hijri'

const convertHijriToGregorian = (dateString) => {
  if (!dateString) return null

  const dateStr = String(dateString).trim()
  const normalized = dateStr.replace(/i/gi, '')
  const parts = normalized.split(/[\/\-]/);

  if (parts.length === 3 && (dateStr.toLowerCase().includes('i') || parts[2] > 1900)) {
    let [day, month, year] = parts.map(Number)

    if (parts[0].length === 4) {
      [year, month, day] = [parts[0], parts[1], parts[2]].map(Number)
    }

    if (month < 1 || month > 12) return null

    if (year >= 1850 && year <= 2100) {
      return normalized
    } else {
      const hijriYear = year < 1000 ? year + 1000 : year
      const hijriMoment = momentHijri()
      hijriMoment.iYear(hijriYear)
      hijriMoment.iMonth(month - 1)
      hijriMoment.iDate(day)

      if (hijriMoment.isValid() && hijriMoment.iDate() === day && hijriMoment.iMonth() === month - 1) {
        const gregorianDate = hijriMoment.format('YYYY-MM-DD')
        console.log('Converted to Gregorian:', gregorianDate)
        return gregorianDate
      } else {
        console.log('Invalid Hijri date components')
        return null
      }
    }
  }

  return dateString
}

export const CalculateAge = birthDate => {
  let age = birthDate
  if (birthDate) {
    const gregorianDate = convertHijriToGregorian(birthDate)

    const today = moment()
    const dob = moment(gregorianDate, ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD-MM-YYYY', 'MM-DD-YYYY', 'MM-DD-YY', 'DD-MM-YY'])

    if (!dob.isValid()) return age

    const years = today.diff(dob, 'years')
    dob.add(years, 'years')
    const months = today.diff(dob, 'months')
    dob.add(months, 'months')
    const days = today.diff(dob, 'days')

    if (years > 0) {
      age = `${years}Y`
    } else if (months > 0) {
      age = `${months}M`
    } else if (days >= 0) {
      age = `${days > 0 ? days : 1}D`
    } else {
      age = `0D`
    }
    return age
  }
}

export const CalculateAgeInYears = birthDate => {
  if (!birthDate) return 0

  const gregorianDate = convertHijriToGregorian(birthDate)

  const today = moment()
  const dob = moment(gregorianDate, ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD-MM-YYYY', 'MM-DD-YYYY', 'MM-DD-YY', 'DD-MM-YY'], true)

  if (!dob.isValid()) return 0

  const years = today.diff(dob, 'years')

  return years < 0 ? 0 : years
}

const parseDateSafe = (input) => {
  if (!input) return null;

  if (input instanceof Date) return input;

  if (!isNaN(input)) return new Date(Number(input));

  let str = String(input).trim();

  const normalized = str.replace(/i/gi, '')
  const parts = normalized.split(/[\/\-]/);

  if (parts.length === 3 && (str.toLowerCase().includes('i') || parts[2] > 1900)) {
    let [day, month, year] = parts.map(Number)

    if (parts[0].length === 4) {
      [year, month, day] = [parts[0], parts[1], parts[2]].map(Number)
    }

    if (month < 1 || month > 12) return null;

    if (year >= 1850 && year <= 2100) {
      return new Date(year, month - 1, day)
    } else {
      const hijriYear = year < 1000 ? year + 1000 : year

      const hijriMoment = momentHijri()
      hijriMoment.iYear(hijriYear)
      hijriMoment.iMonth(month - 1)
      hijriMoment.iDate(day)

      if (hijriMoment.isValid() && hijriMoment.iDate() === day && hijriMoment.iMonth() === month - 1) {
        return hijriMoment.toDate()
      }
    }
  }

  str = str.replace(/[a-zA-Z]/g, "");

  const native = new Date(str);
  if (!isNaN(native)) return native;

  if (parts.length === 3) {
    let [a, b, c] = parts.map(Number);

    if (a > 31) return new Date(a, b - 1, c);
    else return new Date(c, b - 1, a);
  }

  return null;
};


export const calculateDetailedAge = (birthDate) => {
  const birth = parseDateSafe(birthDate);
  if (!birth) return { years: 0, months: 0, days: 0 };

  const today = new Date();

  let years = today.getFullYear() - birth.getFullYear();
  let months = today.getMonth() - birth.getMonth();
  let days = today.getDate() - birth.getDate();

  if (days < 0) {
    months--;
    const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += prevMonth.getDate();
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  return { years, months, days };
};